import script from "./EditEmployees.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditEmployees.vue?vue&type=script&setup=true&lang=ts"

import "./EditEmployees.vue?vue&type=style&index=0&id=040d74ee&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040d74ee"]])

export default __exports__